var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileCenterLogo = function SvgMobileCenterLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.45 4.17l6-4L9 1v4.34l4.42-3.15L15 3v10l-1.58.82L9 10.66V15l-1.55.83-6-4v-1.66L4.7 8 1.45 5.83V4.17zm2.35.86L7 7.16V2.9L3.8 5.03zm4.92 3L12 10.37V5.7L8.72 8.02zM7 8.9l-3.2 2.13L7 13.16V8.9z",
    fillRule: "nonzero"
  })));
};
export default SvgMobileCenterLogo;